<template>
    <div class="area container-fluid">
        <!-- <h5>Filtros de busqueda</h5>
        <hr /> -->
        <div class="row">
            <!-- FILTROS PARA LOS CAMPOS DEL CONTENIDO -->
            <div id="filtros-campos-contenido" class="form-group row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-1 no-gutters">
                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3 pt-1">
                    <h6 style="p-3">Texto en contenido</h6>
                    <input type="text"  v-model="filtrosBusqueda.textoContenido" class="form-control" placeholder="Buscar en texto de contenido"/>
                </div>
                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3 pt-1">
                    <h6 style="p-3">Página</h6>
                    <C007PaginasWeb class="p-0 m-0" 
                        v-on:valorParaElPadre="cambioTipoDePagina" 
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="catalogoPaginas.id" 
                        :parametros="catalogoPaginas.parametros" 
                        :valorDefinido="catalogoPaginas.parametros.paginaId"></C007PaginasWeb>
                </div>
                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3 pt-1" v-if="mostrarSecciones">
                    <h6 style="p-3">Sección</h6>
                    <C008SeccionesDeLaPaginaWeb
                        class="p-0 m-0"
                        v-on:valorParaElPadre="cambioTipoSeccion" 
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="catalogoSeccion.id" 
                        :parametros="catalogoSeccion.parametros" 
                        :valorDefinido="-1" 
                        :key="catalogoSeccion.contRender + 'KEY-SECCIONES-FB'"></C008SeccionesDeLaPaginaWeb>
                </div>
                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3 pt-1" v-for="(subseccion,index) in subSecciones.subseccionesDePagianWeb" :key="index + 'contenedor-subsecciones'">
                    <h6 style="p-3">Subseccion</h6>
                    <CSelectGenerico class="p-0 m-0"
                        v-on:valorParaElPadre="cambioTipoSubseccion" 
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="subseccion.idDelInput" 
                        :valorDefinido="-1" 
                        :key="subseccion.key" 
                        :elementos="subseccion.subsecciones" 
                        :mansajeValorDefinidoPlural="'las secciónes'" 
                        :mansajeValorDefinidoSingular="'un tipo de sección'"></CSelectGenerico>
                </div>
                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3 pt-1">
                     <div>
                        <h6 for="fechaInicial">{{ filtrosBusqueda.textoLFechaFiltro }}</h6>
                        <div id="btn-buscar" class="d-flex justify-content-between">
                            <input type="date" id="fechaInicial" v-model="filtrosBusqueda.fechaInicial" class="form-control" />
                            <button v-if="!filtrosBusqueda.conRangoDeFechas" @click="filtrosBusqueda.fechaInicial = null, filtrosBusqueda.fechaFinal= null" type="button" class="btn-sm btn-primary ml-2"><i class="fas fa-undo-alt"></i></button>
                        </div>
                    </div>
                    <div v-if="filtrosBusqueda.conRangoDeFechas">
                        <h6 for="fechaFinal">Fecha final</h6>
                        <input type="date" id="fechaFinal" v-model="filtrosBusqueda.fechaFinal" class="form-control" />
                    </div>
                </div>
            </div>
            <div v-if="filtrosBusqueda.seccionId > 0 && subSecciones.mostrarSeccionSeleccionada" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-1">
                <div class="d-flex justify-content-end">
                    <button @click="evtBusquedaContenidos" type="button" class="btn btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                </div>
            </div>
            <!-- FIN FILTROS PARA LOS CAMPOS DEL CONTENIDO -->
           <!--  <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1">
                <div class="form-group" style="margin-top:3em;">
                    <div style="display: flex; align-items: center;">
                        <h6 style="margin-right: 0.5em;">Rango de fechas: </h6>
                        <div id="opciones-toggle" class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-secondary" @click="filtrosBusqueda.conRangoDeFechas = true, filtrosBusqueda.textoLFechaFiltro = 'Fecha inicial', filtrosBusqueda.fechaInicial = moment().subtract(5, 'days').format('YYYY-MM-DD'), filtrosBusqueda.fechaFinal = moment().format('YYYY-MM-DD')">
                            <input type="radio" name="options" id="radioVisualizarMapaSi" autocomplete="off" checked>Si
                            </label>
                            <label class="btn btn-secondary active" @click="filtrosBusqueda.conRangoDeFechas = false, filtrosBusqueda.textoLFechaFiltro = 'Fecha de registro', filtrosBusqueda.fechaInicial = null, filtrosBusqueda.fechaFinal = null">
                            <input type="radio" name="options" id="radioVisualizarMapaNo" autocomplete="off">No
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1">
                    <h6 for="fechaInicial">{{ filtrosBusqueda.textoLFechaFiltro }}</h6>
                    <div id="btn-buscar" class="d-flex justify-content-between">
                        <input type="date" id="fechaInicial" v-model="filtrosBusqueda.fechaInicial" class="form-control" />
                        <button v-if="!filtrosBusqueda.conRangoDeFechas" @click="filtrosBusqueda.fechaInicial = null, filtrosBusqueda.fechaFinal= null" type="button" class="btn-sm btn-primary ml-2"><i class="fas fa-undo-alt"></i></button>
                    </div>
                </div>
                <div v-if="filtrosBusqueda.conRangoDeFechas" class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1">
                    <h6 for="fechaFinal">Fecha final</h6>
                    <input type="date" id="fechaFinal" v-model="filtrosBusqueda.fechaFinal" class="form-control" />
                </div>
                <div v-if="filtrosBusqueda.seccionId > 0 && subSecciones.mostrarSeccionSeleccionada" class="d-flex justify-content-end mt-4">
                    <button @click="evtBusquedaContenidos" type="button" class="btn btn-primary ml-2"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import catalogos from '@/../static/js/catalogos'
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import CSelectGenerico from '@/components/SICPO/Comun/CSelectGenerico.vue'
import moment from 'moment'

export default {
    components: {
        C007PaginasWeb: catalogos.SICPO.C007PaginasWeb,
        C008SeccionesDeLaPaginaWeb: catalogos.SICPO.C008SeccionesDeLaPaginaWeb,
        CSelectGenerico
    },
    data() {
        return {
            catalogoPaginas: {
                id: 'catalogoPaginaEdicion',
                parametros: {
                    PaginaDeInicioId: null,
                    MenuId: null,
                    SubmenuId: null,
                    TipoContenedorId: null,
                    ConPaginaDeInicio: false,
                    ConMenu: false,
                    ConSubmenu: false, 
                    ConSecciones: false, 
                    ConInactivas:false, 
                    SoloPermiteSubirContenido: true, 
                    ConOrdenamientoAlfabetico: true
                },
                paginaId: -1,
                contRender: 0
            },
            catalogoSeccion: {
                id: 'catalogoSeccionEdicion',
                parametros: {
                    PaginaWebId: null, 
                    TipoFormatoId: null, 
                    ConSeccionesQueMePertenecen: true, 
                    ConArbolDeSeccionesQueMePertenecen:true, 
                    ConSeccionALaQuePertenezco: false, 
                    ConPaginaWeb: false, 
                    ConOrdenamientoDeLasSecciones: true, 
                    ConCarrusel: true, 
                    FiltrarPorUsuario:true, 
                    ConInactivos:false
                },
                seccionId: -1,
                contRender: 0
            },
            catalogoGenerico: {

            },
            subSecciones: {
                subseccionesDePagianWeb: [],
                arbolSeccionesPaginaWeb: [],
                seccionPadre: [],
                mostrarSeccionSeleccionada: false,
                contRender: 0,
                subseccionesAgregadasTmp: []
            },
            filtrosBusqueda: {
                seccionId: null,
                conRangoDeFechas: false,
                textoLFechaFiltro: 'Fecha de registro',
                fechaInicial: null,
                fechaFinal: moment().format('YYYY-MM-DD'),
                esSubSeccion: false,
                nombreSeccion: null,
                textoContenido: null
            },
            enumeraciones,
            moment,
            mostrarSecciones: false
        }
    },
    methods: {
        evtBusquedaContenidos: function() {
            const FILTROS_BUSQUEDA = {
                paginaWebId: this.campoRequeridoEsValido(this.catalogoPaginas.paginaId) ? this.catalogoPaginas.paginaId : null,
                secccionId: (this.campoRequeridoEsValido(this.filtrosBusqueda.seccionId) && this.subSecciones.mostrarSeccionSeleccionada) 
                                                                    ? this.filtrosBusqueda.seccionId: null,
                fechaInicial: this.filtrosBusqueda.fechaInicial,
                fechaFinal: this.filtrosBusqueda.fechaFinal,
                esSubSeccion: this.filtrosBusqueda.esSubSeccion,
                nombreSeccion: this.filtrosBusqueda.nombreSeccion,
                textoContenido: this.filtrosBusqueda.textoContenido
            }
            this.$emit('BusquedaContenidos', FILTROS_BUSQUEDA);
        },
        cambioTipoDePagina: function(evento) {
            this.catalogoPaginas.paginaId = parseInt(evento.target.value);
            this.catalogoSeccion.parametros.PaginaWebId = parseInt(evento.target.value);
            this.mostrarSecciones = (this.campoRequeridoEsValido(this.catalogoPaginas.paginaId)) ? true : false;
            this.catalogoSeccion.contRender += 3;
            this.asignarCarrusel();
            this.limpiarSubseccciones();
        },
        asignarCarrusel: function() {
            // agregar id de secciones o paginas que tengan carrrusel 12(presidentes).
            const PAGINA_PRESIDENTES_ID = 12;
            const ES_CARRUSEL = (p) => p == PAGINA_PRESIDENTES_ID; 
            this.catalogoSeccion.parametros.ConCarrusel = (ES_CARRUSEL(this.catalogoPaginas.paginaId)) ? true : false;
            //console.log('carrusel::',this.catalogoSeccion.parametros.ConCarrusel);
        },
        limpiarSubseccciones: function() {
            this.subSecciones.subseccionesDePagianWeb = [];
            this.subSecciones.seccionPadre = [];
            this.subSecciones.subseccionesAgregadasTmp = 0;
            this.subSecciones.mostrarSeccionSeleccionada = false;
        },
        cambioTipoSeccion: function(evento,arbolSeccionesPw) { 
            this.limpiarSubseccciones(); 
            this.catalogoSeccion.arbolSeccionesPaginaWeb = arbolSeccionesPw;
            this.catalogoSeccion.seccionId = parseInt(evento.target.value);
            this.subSecciones.seccionPadre = arbolSeccionesPw;
            this.seccionesPermiteSubirContenido(this.catalogoSeccion.seccionId,this.subSecciones.seccionPadre);
            this.agregarSubseccion(this.catalogoSeccion.seccionId,this.subSecciones.seccionPadre);
            this.filtrosBusqueda.seccionId =  this.catalogoSeccion.seccionId;
            this.filtrosBusqueda.nombreSeccion = evento.target.options[evento.target.selectedIndex].text;
            this.filtrosBusqueda.esSubSeccion = false;
        },
        seccionesPermiteSubirContenido: function(idSeccion,seccionPadre) { 
            const VALOR_ICORRECTO = -1;
            let indexSeccion = -1;
            let permiteSubirContenido = false;
          
            if(seccionPadre != null && seccionPadre.length > 0 && idSeccion != VALOR_ICORRECTO) {
                indexSeccion = seccionPadre.findIndex(s => s.SeccionDeLaPaginaWebId == idSeccion);
                permiteSubirContenido = (seccionPadre[indexSeccion].PermiteSubirContenido) ? true: false;
            }

            this.subSecciones.mostrarSeccionSeleccionada = true;
            if(idSeccion == VALOR_ICORRECTO || !permiteSubirContenido) {
                this.subSecciones.mostrarSeccionSeleccionada = false;
            }
        },
        agregarSubseccion: function(idSeccion,seccionPadre) { 
            // se valida que no cree subsecciones si su valor es el valor predefinido (no valido)
            if(this.campoRequeridoEsValido(idSeccion)) {
                let subsecciones = seccionPadre.find(subseccion => subseccion.SeccionDeLaPaginaWebId == idSeccion).SeccionesQueMePertenecen;
                if(subsecciones != null && subsecciones != undefined && subsecciones.length > 0) {
                    this.subSecciones.seccionPadre = subsecciones;
                    let objetoSubseccion = this.construirObjetoSubseccion(subsecciones);
                    this.subSecciones.subseccionesDePagianWeb.push(objetoSubseccion);
                }
            }
        },
         construirObjetoSubseccion: function(listaSubsecciones) { 
            let objetoSubseccion = {};
            let identificadorInput = 'subseccion';
            let idInputSubseccion = identificadorInput + this.subSecciones.contRender;
            let keyInputSubseccion = identificadorInput + this.subSecciones.contRender;
            objetoSubseccion.idDelInput = idInputSubseccion;
            objetoSubseccion.key = keyInputSubseccion;
            objetoSubseccion.subsecciones = [];
            objetoSubseccion.seccionPadre = this.subSecciones.seccionPadre;
            listaSubsecciones.forEach(subseccion => {
                let valoresSubseccion = {
                    valor: subseccion.SeccionDeLaPaginaWebId,
                    nombre: subseccion.NombreDeLaSeccion
                };
                objetoSubseccion.subsecciones.push(valoresSubseccion);
            });
            this.subSecciones.contRender ++;
            return objetoSubseccion;
        },
        cambioTipoSubseccion: function(evento) { 
            let idSubseccionEnEvento = evento.target.getAttribute('id');
            let agregarSeccionNavegacion = false;
            let eliminoSeccionDeNavegacion = false;
            let numeroDeSubsecciones = this.subSecciones.subseccionesDePagianWeb.length;
            let indexSubseccion = this.subSecciones.subseccionesDePagianWeb.findIndex(
                subseccion =>  subseccion.idDelInput == idSubseccionEnEvento
            );
            let indexSeccion = (indexSubseccion + 1);
            let eliminarDesde = (indexSubseccion + 1);
            let numeroSubseccionesEliminar = (numeroDeSubsecciones - eliminarDesde);
            
            if(numeroSubseccionesEliminar > 0){
                for(let i=0;i<numeroSubseccionesEliminar;i++){
                    this.subSecciones.subseccionesDePagianWeb.pop();
                }
                // se le suma uno para eliminar hasta el index actual del array
                indexSeccion = (indexSubseccion + 1);
            }

            this.subSecciones.subseccionesAgregadasTmp = numeroDeSubsecciones;

            this.subSecciones.contRender ++;
            this.seccionesPermiteSubirContenido(evento.target.value,this.subSecciones.subseccionesDePagianWeb[indexSubseccion].seccionPadre);
            this.agregarSubseccion(parseInt(evento.target.value),this.subSecciones.subseccionesDePagianWeb[indexSubseccion].seccionPadre);
            this.filtrosBusqueda.seccionId =  parseInt(evento.target.value);
            this.filtrosBusqueda.nombreSeccion = evento.target.options[evento.target.selectedIndex].text;
            this.filtrosBusqueda.esSubSeccion = true;
        },
        campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      }
    },
    created() {
        
    },
}
</script>
<style scoped>

#btn-buscar .btn-sm {
    cursor: pointer;
    padding: 6px 10px 6px 10px;
    background-color: #555558;
}

#btn-buscar .btn-sm:hover {
    background-color: black;
}

#opciones-toggle .btn-secondary:not(:disabled):not(.disabled).active, 
#opciones-toggle .btn-secondary:not(:disabled):not(.disabled):active, .show > #opciones-toggle .btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}

#opciones-toggle .btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
}

#opciones-toggle .btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/BusquedaDeDocumentos/CFiltrosDeContenidos.vue